export default 9.59